<template>
  <q-page padding class="my-login">
    <!-- content -->
    <div class="">
      <div class="row justify-center">
        <div class="col-auto"></div>
        <div class="col-auto">
          <div class="title" style="padding-bottom:30px; padding-top:50px">
            <span class="text-h4 text-primary">
              Zem<span class="text-accent">a</span>
              <sup class="text-overline text-weight-thin">
                Schuladministration
              </sup>
            </span>
          </div>
          <form
            @submit.prevent.stop="onSubmit"
            @reset.prevent.stop="onReset"
            class="q-gutter-sm"
            :style="$q.platform.is.desktop ? 'width:340px' : 'width:300px'"
          >
            <q-input
              outlined
              square
              dense
              ref="username"
              v-model="username"
              placeholder="Benutzername"
              lazy-rules
              :rules="[
                val =>
                  (val && val.length > 2) ||
                  'Bitte einen Benutzernamen eingeben'
              ]"
            >
            </q-input>
            <q-input
              outlined
              square
              dense
              ref="password"
              v-model="password"
              :type="isPwd ? 'password' : 'text'"
              placeholder="Passwort"
              lazy-rules
              :rules="[
                val => (val && val.length > 2) || 'Bitte ein Passwort eingeben'
              ]"
            >
              <template v-slot:append>
                <q-icon
                  :name="isPwd ? 'visibility_off' : 'visibility'"
                  class="cursor-pointer"
                  @click="isPwd = !isPwd"
                />
              </template>
            </q-input>
            <div style="padding-top:10px;">
              <q-btn
                style="width:100%;border-radius:0px;"
                outline
                :loading="loginButtonLoading"
                label="Anmelden"
                type="submit"
                color="primary"
              />
            </div>
          </form>
        </div>
        <div class="col-auto"></div>
      </div>
    </div>
  </q-page>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Login',
  data () {
    return {
      password: '',
      isPwd: true,
      username: ''
    }
  },
  computed: {
    ...mapGetters('auth', ['loginButtonLoading'])
  },

  methods: {
    onSubmit () {
      this.loading = true
      this.$refs.username.validate()
      this.$refs.password.validate()

      if (this.$refs.username.hasError || this.$refs.password.hasError) {
        this.formHasError = true
      } else {
        this.$store.dispatch('auth/login', {
          username: this.username,
          password: this.password
        })
        //        this.$q.notify({
        //          icon: 'done',
        //          color: 'positive',
        //          message: 'Submitted'
        //        });
      }
    },

    onReset () {
      this.username = null
      this.password = null

      this.$refs.username.resetValidation()
      this.$refs.password.resetValidation()
    }
  }
}
</script>

<style lang="stylus" scoped>
.my-login {
  // background: #002140;
}
</style>
